import { User } from 'model';
import { ChangeEvent, useState } from 'react';
import { Input } from '../../components/Forms/Input.js';
import { UserItem } from '../../components/admin/UserItem.js';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../../styles/Shared.module.css';
import styles from './BuyTokenModal.module.css';

export const BuyTokenModal: React.FC<{
	user: User | undefined | null;
	setBuyTokenAmountSubmit: (val: number) => void;
}> = ({ user, setBuyTokenAmountSubmit }) => {
	const [tokenAmount, setTokenAmount] = useState<number | ''>('');

	const setValues = (e: ChangeEvent<HTMLInputElement>) => {
		const inputValue = e.target.value === '' ? '' : Number(e.target.value);
		setTokenAmount(inputValue);
		setBuyTokenAmountSubmit(Number(inputValue));
	};

	return (
		<div>
			<div className={sharedStyles.userContainer}>{user && <UserItem user={user} modal={true} />}</div>
			<h4 style={{ marginBottom: '40px' }}>
				Purchase Tokens
				<br /> <i>$1 each, $100 max</i>
			</h4>
			<div className={styles.dollarFormField}>
				{user && (
					<Input
						testId="buyTokenAmount"
						className={styles.quantity}
						type="number"
						placeholder="Quantity"
						tabIndex={1}
						value={tokenAmount}
						min="0"
						max="100"
						step="1"
						onChange={setValues}
					/>
				)}
			</div>
			<div className="space20" />
		</div>
	);
};
